module.exports = __webpack_public_path__ + "static/media/pig.9dff8766.svg";